import { render, staticRenderFns } from "./amendChild.vue?vue&type=template&id=3ed1509d"
import script from "./amendChild.vue?vue&type=script&lang=js"
export * from "./amendChild.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports